// SPDX-FileCopyrightText: 2017-2025 City of Espoo
//
// SPDX-License-Identifier: LGPL-2.1-or-later

import type { CustomizableStaffAttendanceType } from '../types'

export const additionalStaffAttendanceTypes: CustomizableStaffAttendanceType[] =
  ['OTHER_WORK', 'TRAINING', 'JUSTIFIED_CHANGE']
